export type AccountUpdateMessageEvent = 'UPDATE' | 'DELETE';
export const AccountUpdateMessageEvent = {
  UPDATE: 'UPDATE' as AccountUpdateMessageEvent,
  DELETE: 'DELETE' as AccountUpdateMessageEvent,
};
